import { ParentDashboard } from '@/components/app/parent'
import { AdminDashboard } from '@/components/app/admin'
import { AuthAPI } from '@/services/api'
import { useEffect, useState } from 'react'
import { Loader2 } from 'lucide-react'

const Dashboard = () => {
  const [user, setUser] = useState<any>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    AuthAPI.me()
      .then((data) => setUser(data.user))
      .catch(() => {
        // If auth fails, redirect to login
        window.location.href = '/auth/login'
      })
      .finally(() => setIsLoading(false))
  }, [])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    )
  }

  if (!user) return null

  if (user.role === 'ADMIN') {
    return <AdminDashboard />
  }

  return <ParentDashboard />
}

export default Dashboard